export enum LanguageEnum {
  HR = 'hr',
  EN = 'en'
}
